export const hrefFromUrlObject = (urlObject: {
    pathname
    query: { [key: string]: string }
}): string => {
    const { pathname, query } = urlObject
    const queryString = Object.entries(query)
        .filter(([, value]) => value !== undefined && value !== null)
        .map(
            ([key, value]) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
        )
        .join('&')

    return queryString ? `${pathname}?${queryString}` : pathname
}
